<template>
<v-container>
  <v-row>
    <v-col class="xs-8" cols="8">
      <v-card>
        <v-toolbar>
          <v-toolbar-title class="ml-3 mr-3">{{$t('Project.Settings.DeleteProject.Title')}}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-text-field v-model="project_name" :label="$t('Project.Settings.DeleteProject.Placeholder')"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="!loading" color="red lighten-1 mr-2" :disabled="getProjectName(project_id) != project_name" @click="deleteProjectButton(project_id)">
            <v-icon class="mr-2">delete</v-icon>
            {{$t('Project.Settings.DeleteProject.Button')}}
          </v-btn>
          <LoadingButton v-else text="Delete Project" :color="'red lighten-1'" ></LoadingButton>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>
<script>
import store from '@/store/index'
import router from '@/router/index'
import LoadingButton from '@/components/UserFeedback/LoadingButton.component.vue'
import {
  mapGetters,
  mapActions
} from 'vuex';

export default {
  data() {
    return {
      project_name: '',
      loading: false
    }
  },
  components: {
    LoadingButton
  },
  name: 'ProjectDelete',
  computed: {
    ...mapGetters('Project', [
      'getProjectName',
    ]),
    project_id() {
      return parseInt(this.$route.params.project_id);
    },
  },
  beforeRouteEnter(to, from, next) {
    if (!store.getters['Project/hasProjectPermission']({
      project_id: to.params.project_id,
      ppermission: 'Delete Project'
    })) {
      router.push({
        name: 'ProjectSettings',
        params: {
          project_id: to.params.project_id
        }
      })
    } else {
      next();
    }
  },
  methods: {
    ...mapActions('Project', [
      'deleteProject'
    ]),
    deleteProjectButton(){
      this.loading = true;
      this.deleteProject(this.project_id);
    }
  }
}
</script>
